import cx from "classnames";
import React from "react";
import { I18n } from "react-redux-i18n";

import { SkipLogic } from "@common/components/skip-logic";
import { SkipLogicCondition, SkipLogicPredefinedControlType } from "@common/components/skip-logic/skip-logic.types";

import "./conditions-builder.styles.scss";

type ConditionsBuilderProps = {
  className?: string;
  moduleName: string;
  conditions: Array<SkipLogicCondition>;
  onChange: (conditions: SkipLogicCondition[]) => void;
  onAllConditionsRemove: () => void;
  onDrop?: () => void;
};

export const ConditionsBuilder: React.FC<ConditionsBuilderProps> = ({
  className,
  moduleName,
  conditions,
  onChange,
  onAllConditionsRemove,
}) => {
  return (
    <div className={cx("SpreadsheetDetailsConditionsBuilder", className)}>
      {!conditions.length && (
        <span className="SpreadsheetDetailsConditionsBuilder__drag-drop-message">
          {I18n.t("Move Fields From Columns Panel Above")}({I18n.t("Or")}
          {I18n.t("Drag Fields From Warehouse And Drop Here")})
        </span>
      )}
      <SkipLogic
        moduleName={moduleName}
        className="SpreadsheetDetailsConditionsBuilder__skip-logic"
        conditions={conditions}
        onRemove={onChange}
        onChange={onChange}
        onAdd={() => {}}
        getFolders={() => {
          return Promise.resolve([]);
        }}
        getFields={() => {
          return Promise.resolve([]);
        }}
        controls={[
          { type: SkipLogicPredefinedControlType.moveUp, handler: onChange },
          { type: SkipLogicPredefinedControlType.moveDown, handler: onChange },
          { type: SkipLogicPredefinedControlType.removeAll, handler: onAllConditionsRemove },
        ]}
      />
    </div>
  );
};
